import { getCurrencySymbol } from './region-config';

/**
 * Форматирует число как валюту контура: RU — «4 133 ₽», KZ — «4 133 ₸».
 *
 * Символ берётся из getCurrencySymbol() (window.currencySymbol, который backend
 * кладёт из CURRENCY_SYMBOL контура — см. app/views/shared/_region_globals.html.slim).
 * Через Intl символ брать нельзя: в локали ru он для KZT равен «KZT», а не «₸»,
 * и на одной странице встречались оба варианта — код ISO в корзине и знак ₸
 * в карточке товара, которую рисует сервер.
 *
 * Разделитель разрядов и запятая — из локали ru-RU; между числом и символом
 * неразрывный пробел, чтобы знак не отрывался от суммы при переносе строки.
 *
 * Если precision не указан, автоматически определяет:
 *   - 0 знаков для целых чисел
 *   - 2 знака для дробных
 */
export function toCurrency(number: number | string, precision?: number): string {
  const numericValue = Number(number) || 0;
  const hasFractionalPart = Math.round(Math.abs(numericValue) * 100) % 100 !== 0;
  const resolvedPrecision = precision == null ? (hasFractionalPart ? 2 : 0) : precision;

  const formattedNumber = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: resolvedPrecision,
    maximumFractionDigits: resolvedPrecision
  }).format(numericValue);

  return `${formattedNumber}\u00a0${getCurrencySymbol()}`;
}
